import {ChangeDetectionStrategy, Component} from '@angular/core';
import {DialogService} from '../services/dialog.service';

@Component({
    selector: 'app-dialog-host',
    templateUrl: './dialog-host.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogHostComponent {
    constructor(readonly dialogService: DialogService) {
    }
}
